export default __webpack_public_path__ + "images/icon_4020c3.svg";